import axios from "axios";

const STAGE_SOCKET_URL = "https://staging-communication.apollosoft.co";
const PROD_SOCKET_URL = "https://communication.apollosoft.co";
let SERVER_URL = "http://localhost:3003";

if (process.env.REACT_APP_API_URL !== undefined) {
  SERVER_URL =
    process.env.REACT_APP_API_URL.indexOf(
      "staging-callcenter-admin.apollosoft"
    ) >= 0
      ? STAGE_SOCKET_URL
      : PROD_SOCKET_URL;
}

export async function getUserByEmail(email: string) {
  const response = await axios.get(`${SERVER_URL}/user/get-user-by-email`, {
    params: { email },
  });
  return response.data;
}

export default { getUserByEmail };
